<template>
  <div class="hobbies">
    <Header header="kone"/>
    <b-container class="questions content-normal pb-5">
      <b-row>
        <b-form-invalid-feedback :state="state">{{ $t('general.max') }} {{ max }}</b-form-invalid-feedback>
        <b-form-valid-feedback :state="state">OK!</b-form-valid-feedback>
        <b-col md="4" class="py-2 px-1" v-for="h in getHobbies" :key="h.id">
          <b-form-checkbox class="kone-btn" name="check-button" :value=h.id :state="state" v-model="locations"
                           :disabled="disableCb(h.id)" button>{{ h.title }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-button :disabled="disable" @click="next" class="kone-continue">{{ $t('general.continue') }}</b-button>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from './Header'
import router from '@/router'

export default {
  name: 'Hobbies',
  components: { Header },
  props: {
    section: String
  },
  data () {
    return {
      locations: [],
      max: this.$store.state.max.hobbies
    }
  },
  computed: {
    ...mapGetters(['getHobbies', 'getWinner']),
    state () {
      return this.locations.length >= 1 && this.locations.length <= this.max
    },
    disable () {
      return this.locations.length < 1 || this.locations.length > this.max
    }
  },
  methods: {
    addPoints () {
      const points = []
      for (const p of this.locations) {
        for (const r of this.getHobbies) {
          if (p === r.id) {
            points.push(...r.location_ids)
          }
        }
      }
      console.debug(points)
      return points
    },
    next () {
      this.$store.commit('addPoints', this.addPoints())
      this.$store.commit('setPos', 'result')
      this.$store.dispatch('setResults')
      router.push({ name: 'result', params: { tulos: this.getWinner.param } })
    },
    disableCb (value) {
      return !this.locations.includes(value) && this.locations.length > this.max
    }
  }
}
</script>
